<script setup>
import { useRoute } from 'vue-router'
import { ref, computed } from 'vue'
import GbButton from './GbButton.vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from './../authentication/user.store'
import { useUserFeedbackContext } from './useUserFeedbackContext'

const props = defineProps({
  type: {
    type: String,
    required: true
  }
})

const googleFormBaseUrl = ref(
  'https://docs.google.com/forms/d/e/1FAIpQLScN5SYu0YNCympe4S1XorZyiU7KJGcGhmZPhvyHD1WsparzLA/viewform?'
)

const userStore = useUserStore()
const { user, isAuthenticated } = storeToRefs(userStore)
const route = useRoute()

const { context: feedbackContext } = useUserFeedbackContext()

// Get values from feedback context
const uuid = computed(() => feedbackContext.value.uuid || '')
const title = computed(() => feedbackContext.value.title || '')
const subject = computed(() => feedbackContext.value.subject || '')

const currentUrl = computed(() => {
  const absoluteURL = new URL(route.fullPath, window.location.origin).href
  return absoluteURL
})

const formParams = computed(() => {
  return new URLSearchParams({
    'entry.511727829': user.value.name,
    'entry.13770077': user.value.email,
    'entry.305088804': title.value,
    'entry.1207187100': uuid.value,
    'entry.1819560062': subject.value,
    'entry.646615767': currentUrl.value,
    'entry.2087380084': props.type,
    'entry.885705844': 'Toolkit'
  })
})

const generatedFeedbackLink = computed(() => {
  return `${googleFormBaseUrl.value}${formParams.value.toString()}`
})

function openLink(url) {
  window.open(url, '_blank')
}
</script>
<template>
  <p class="container text-md pt-20" v-if="isAuthenticated">
    Have any feedback about this page?
    <GbButton
      gbTheme="grayOutlineSecondary"
      size="small"
      label="Submit Feedback"
      class="!align-baseline"
      @click="openLink(generatedFeedbackLink)"
    />
  </p>
</template>
